/* eslint-disable no-undef, no-empty */

/**
 * https://github.com/getsentry/sentry-docs/blob/master/src/collections/_documentation/platforms/javascript/advance-settings.md
 * http://gitlab.ri.domain/frontend/errno
 */

class Logger {
  constructor() {
    this.enabled = process.env.TARGET !== 'development' && typeof Sentry !== 'undefined';

    if (this.enabled) {
      try {
        this.errno = new window.Errno({
          dsn: SENTRY_DSN,
          release: PARTNER_PAGE_VERSION,
          environment: process.env.TARGET,
          integrations: [...Sentry.defaultIntegrations],
        });
        window.__SENTRY__.errno = this.errno;
      } catch (error) {
        this.enabled = false;
      }
    }
  }

  log = (message) => {
    if (!this.enabled) return;

    try {
      this.errno.captureMessage(message);
    } catch (e) { }
  };

  error = (exception, options) => {
    if (!this.enabled) return;

    try {
      this.errno.captureException(exception, options);
    } catch (e) { }
  };

  showError = (message) => {
    if (!this.enabled) return;

    const text = message;
    const traceId = null;
    const delay = 0;

    this.errno.showError(text, traceId, delay);
  };

  logErrorAndShowErrorMessage = (exception, message, options) => {
    this.error(exception, options);
    this.showError(message);
  };
}

export default new Logger();
